import { gql } from '@apollo/client';

/**
 * 日报查询。
 *
 * `risks` 只取实际渲染的字段：日报的上游 `DailyReportRiskDTO` 远薄于告警，
 * `params` / `entities` / `trend` / `actions` / `triggerReason` 等在这条链路上恒为空（plan 3-6），
 * 选出来既是无谓的载荷，也会让人误以为它们有值。若日后上游把风险结构补齐，再按需增选。
 * `alertTypeCode` 例外：「已处理」记录带 `subType`，是圆点配色的唯一依据。
 */
export const WORKBENCH_SHIFT_REPORT = gql`
  query WorkbenchShiftReport($warehouseId: Long!) {
    workbenchShiftReport(warehouseId: $warehouseId) {
      available
      unavailableReason
      reportId
      warehouseId
      reportDate
      status
      autoSendAtText
      sentAt
      lastEditedAt
      canEdit
      summary {
        tasksDone
        tasksTotal
        tasksStillOpen
        alertsHandled
        alertsTotal
        returnParcelsDone
        returnParcelsTotal
      }
      kpis {
        metricKey
        valueText
        rawValue
        dodChangeText
        dodChange
        severity
        trend {
          label
          value
        }
      }
      risks {
        alertId
        alertTypeCode
        severity
        headline
        handleStatus
        # 通过「联系 DSP」这类动作处理掉的风险没有留言，处理人与处理时刻只在这两个字段上
        handledByName
        handledAt
        comment {
          content
          byName
          at
          canEdit
        }
      }
      # 当日未处理的周期复盘风险（open 状态的 AGENT_PERIOD 条目），字段结构同 risks，
      # 与已处理的 risks 不重叠 —— 处理时刻仍为空、handleStatus 由后端固定填 HANDLED，不用于展示
      unresolvedPeriodRisks {
        alertId
        alertTypeCode
        severity
        headline
        handleStatus
        handledByName
        handledAt
        comment {
          content
          byName
          at
          canEdit
        }
      }
      unhandledAlertCount
      remark
    }
  }
`;
